export const baseQueryOptions = { notifyOnChangeProps: ['data', 'isFetching'] };
